import React, { FC } from 'react';
import { useTranslations } from '@lang';
import {
  SignInDescription,
  SignInSection,
  SignInDescriptionMobile,
  StyledButton,
  StyledAnchor,
} from './SignInBox.styles';

export type SignInBoxProps = {
  handleModalOpen: () => void;
  isSignedIn?: boolean;
};

export const SignInBox: FC<SignInBoxProps> = ({ handleModalOpen, isSignedIn = false }) => {
  const { t } = useTranslations();
  return isSignedIn ? null : (
    <SignInSection>
      <SignInDescription>{t('checkout.signInDescription')}</SignInDescription>
      <StyledButton isPrimary onClick={handleModalOpen}>
        {t('signIn.label')}
      </StyledButton>
      <SignInDescriptionMobile>
        {t('signIn.description')}
        <StyledAnchor target="_blank" onClick={handleModalOpen}>
          {t('signIn.label')}
        </StyledAnchor>
      </SignInDescriptionMobile>
    </SignInSection>
  );
};
